import type { SxProps, Theme } from '@mui/material/styles';
import { neutral } from '_lex/_foundations/phxColors';

export const readOnlyDashedTextFieldSx: SxProps<Theme> = {
  '&.MuiFormControl-root': {
    paddingTop: 4,
  },
  '& .MuiOutlinedInput-root': {
    minHeight: 45,
    bgcolor: neutral[50],
    borderRadius: 2,
    '& fieldset': {
      borderStyle: 'dashed',
      borderColor: neutral[300],
    },
    '&:hover fieldset': {
      borderStyle: 'dashed',
      borderColor: neutral[300],
    },
    '&.Mui-focused fieldset': {
      borderWidth: 1,
      borderStyle: 'dashed',
      borderColor: neutral[300],
    },
  },
  '& .MuiInputBase-input': {
    cursor: 'default',
    py: 2.25,
    px: 2.5,
    fontSize: '0.875rem',
    fontWeight: 500,
    color: neutral[500],
    lineHeight: 1.5,
    boxSizing: 'border-box',
  },
};

export const editableStepTextFieldSx: SxProps<Theme> = {
  '&.MuiFormControl-root': {
    paddingTop: 4,
  },
  '& .MuiOutlinedInput-root': {
    minHeight: 45,
    bgcolor: neutral[25],
    borderRadius: 2,
    '& fieldset': {
      borderColor: neutral[200],
    },
    '&:hover fieldset': {
      borderColor: neutral[300],
    },
    '&.Mui-focused fieldset': {
      borderWidth: 1,
      borderColor: neutral[300],
    },
  },
  '& .MuiInputBase-input': {
    py: 2.25,
    px: 2.5,
    fontSize: '0.875rem',
    fontWeight: 500,
    color: neutral[800],
    lineHeight: 1.5,
    boxSizing: 'border-box',
  },
};
